import { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { Header } from '@/components/layout/Header'
import { Footer } from '@/components/layout/Footer'
import { BottomNav } from '@/components/layout/BottomNav'
import { ToastContainer } from '@/components/common/Toast'
import { AuthModals } from '@/components/auth/AuthModals'
import { MessageModal } from '@/components/messages/MessageModal'
import { useAuthInit } from '@/hooks/useAuth'
import { useCartSubscription } from '@/hooks/useCart'
import { useNotificationSubscription } from '@/hooks/useNotifications'
import { useUIStore } from '@/store/uiStore'
import { CartDrawer } from '@/components/cart/CartDrawer'

export function App() {
  // Initialize auth listener on app mount
  useAuthInit()

  // Subscribe to cart (real-time Firestore listener)
  useCartSubscription()

  // Subscribe to notifications (real-time Firestore listener)
  useNotificationSubscription()

  // Scroll to top on route changes
  const { pathname } = useLocation()
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  const { activeModal, modalData, closeModal } = useUIStore()
  const isMessagesRoute = pathname.startsWith('/messages')

  return (
    <div className="min-h-screen flex flex-col bg-slate-50">
      {/* Skip to content link for keyboard navigation */}
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-50 focus:bg-primary-500 focus:text-white focus:px-4 focus:py-2 focus:rounded-lg focus:text-sm focus:font-medium focus:outline-none"
      >
        Skip to main content
      </a>
      <Header />
      <main id="main-content" className={isMessagesRoute ? 'flex-1 overflow-hidden' : 'flex-1'}>
        <Outlet />
      </main>
      {!isMessagesRoute && <Footer />}
      <BottomNav />
      <AuthModals />
      <MessageModal
        isOpen={activeModal === 'message'}
        onClose={closeModal}
        data={activeModal === 'message' ? modalData as {
          listingId: string
          sellerId: string
          sellerName: string
          listingTitle: string
          listingImage?: string
          listingPrice?: number
        } : undefined}
      />
      <CartDrawer />
      <ToastContainer />
    </div>
  )
}
